import { Components, Theme } from "@mui/material"

import { MuiButton } from "./MuiButton"
import { MuiButtonBase } from "./MuiButtonBase"
import { MuiCssBaseline } from "./MuiCssBaseline"
import { MuiFormControlLabel } from "./MuiFormControlLabel"
import { MuiFormHelperText } from "./MuiFormHelperText"
import { MuiIconButton } from "./MuiIconButton"
import { MuiInputBase } from "./MuiInputBase"
import { MuiLinearProgress } from "./MuiLinearProgress"
import { MuiLink } from "./MuiLink"
import { MuiTab } from "./MuiTab"
import { MuiTableBody } from "./MuiTableBody"
import { MuiTableCell } from "./MuiTableCell"
import { MuiTableHead } from "./MuiTableHead"
import { MuiTabs } from "./MuiTabs"
import { MuiTextField } from "./MuiTextField"
import { MuiToggleButton } from "./MuiToggleButton"
import { MuiToggleButtonGroup } from "./MuiToggleButtonGroup"
import { MuiTypography } from "./MuiTypography"
export const components: Components<Theme> = {
  MuiButton,
  MuiButtonBase,
  MuiCssBaseline,
  MuiFormControlLabel,
  MuiFormHelperText,
  MuiIconButton,
  MuiInputBase,
  MuiLinearProgress,
  MuiLink,
  MuiTab,
  MuiTableBody,
  MuiTableCell,
  MuiTableHead,
  MuiTabs,
  MuiTextField,
  MuiToggleButton,
  MuiToggleButtonGroup,
  MuiTypography,
}
